import {Identifier, RecordType} from 'components/record/RecordContext';
import React, {useEffect} from 'react';
import {ListFiltersType} from './List';

export const createListContext = () =>
  React.createContext<ListContextValue<RecordType>>({
    refetch: () => {},
    addFilters: () => {},
    filters: {},
    selected: [],
    setSelected: () => {},
    list: [],
    setList: () => {},
    total: 0,
    setTotal: () => {},
    isOrderable: false
  });

export const ListContext = createListContext();

export type ListContextValue<RecordType> = {
  refetch?: () => void;
  filters?: ListFiltersType;
  addFilters?: (filters: ListFiltersType) => void;
  selected: Identifier[];
  setSelected: React.Dispatch<React.SetStateAction<Identifier[]>>;
  list: RecordType[];
  setList: React.Dispatch<React.SetStateAction<RecordType[]>>;
  total: number;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  isOrderable?: boolean;
};

export const ListContextProvider = ({children, refetch, filters, addFilters, data, isOrderable}: ListContextProviderProps) => {
  const [selected, setSelected] = React.useState<Identifier[]>([]);
  const [list, setList] = React.useState<RecordType[]>(data.list);
  const [total, setTotal] = React.useState<number>(data.total);
  useEffect(() => {
    setList(data.list);
    setTotal(data.total);
  }, [data]);
  return (
    <ListContext.Provider value={{refetch, selected, setSelected, filters, addFilters, list, setList, total, setTotal, isOrderable}}>
      {children}
    </ListContext.Provider>
  );
};

export interface ListContextProviderProps {
  children: React.ReactNode;
  refetch?: () => void;
  filters?: ListFiltersType;
  addFilters?: (filters: ListFiltersType) => void;
  data: {list: RecordType[]; total: number};
  isOrderable?: boolean;
}

export const useListContext = (): ListContextValue<RecordType> => {
  const context = React.useContext(ListContext);
  return context as unknown as ListContextValue<RecordType>;
};
